import { render } from "./ExperienceComponent.vue?vue&type=template&id=0d8010bf&scoped=true"
import script from "./ExperienceComponent.vue?vue&type=script&lang=js"
export * from "./ExperienceComponent.vue?vue&type=script&lang=js"

import "./ExperienceComponent.vue?vue&type=style&index=0&id=0d8010bf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8010bf"]])

export default __exports__